<template>
    <div class="row mb-5 pb-5">
        <div class="col-12">
            <errors :error_bag="error_bag"></errors>
        </div>
        <div class="col-md-6 col-12">
            <div v-if="issue == undefined">
                <h2>Details</h2>
                <div class="form-floating my-4" v-show="projects.length > 1">
                    <select id="issue-project-affected-input" class="form-select focus-ring focus-ring-primary" name="project_id" v-model="selectedProjectId">
                        <option v-for="project in projects" :value="project.id" :key="project.id">{{ project.name }}</option>
                    </select>
                    <label for="issue-project-affected-input">Project *</label>
                </div>
                <div class="form-floating my-4" v-show="filteredProjectElements.length > 1">
                    <select id="issue-element-affected-input" class="form-select focus-ring focus-ring-primary" name="element_affected_id">
                        <option v-for="element in filteredProjectElements" :value="element.id" :key="element.id">{{ element.name }}</option>
                    </select>
                    <label for="issue-element-affected-input">Element affected *</label>
                </div>
                <div class="my-4">
                    <div class="input-group">
                        <div class="form-floating">
                            <input id="issue-jira_summary-input" name="jira_summary" placeholder="Ticket title *" class="form-control focus-outline focus-outline-primary focus-ring focus-ring-primary" required v-model="jiraSummary">
                            <label for="issue-jira_summary-input">Summary *</label>
                        </div>
                    </div>
                    <small class="my-1">Please provide a summary of the issue (20 words and 255 characters maximum)</small>
                </div>
                <div class="form-floating">
                    <textarea id="issue-full-description-input" name="jira_description" class="form-control" placeholder="Full Description *" rows="8" required v-model="jiraDescription"></textarea>
                    <label for="issue-full-description-input">Detailed Description *</label>
                    <small class="my-1">Please explain the issue in more detail. You can upload images in the “Evidence” section of this page and reference a URL below.</small>
                </div>
            </div>
            <div v-if="issue != undefined">
                <h2 class="my-3">Provide Update</h2>
                <p>Please detail any information that you’d like to add as an update. This will be added onto the original task as a comment which can be viewed by Project Managers and Developers.</p>
                <div class="form-floating">
                    <textarea id="issue-update-input" name="jira_description" class="form-control" placeholder="Update *" rows="8" v-model="jiraUpdate" required></textarea>
                    <label for="issue-update-input">Update *</label>
                </div>
            </div>
            <div class="my-4">
                <div class="input-group">
                    <div class="form-floating">
                        <input id="issue-url-input" name="url" placeholder="URL (if applicable)" class="form-control focus-outline focus-outline-primary focus-ring focus-ring-primary" v-model="jiraUrl">
                        <label for="issue-url-input">URL (if applicable)</label>
                        <small v-if="issue != undefined" class="my-1">Please leave blank if this the same URL as listed in the original ticket above.</small>
                    </div>
                </div>
            </div>
            <h2 class="my-3">Impact</h2>
            <p v-if="issue != undefined">This section should be left blank if this is unchanged from the first reporting of this ticket.</p>
            <p class="mt-4">How many {{ filteredTerm }} are directly affected?</p>
            <div class="form-check my-2">
                <input class="form-check-input" type="radio" name="impact_count" id="issue-input-count-input-none" value="none" :checked="impact_count == 'none'">
                <label class="form-check-label" for="issue-input-count-input-none">None</label>
            </div>
            <div class="form-check my-2">
                <input class="form-check-input" type="radio" name="impact_count" id="issue-input-count-input-one" value="one" :checked="impact_count == 'one'">
                <label class="form-check-label" for="issue-input-count-input-one">One</label>
            </div>
            <div class="form-check my-2">
                <input class="form-check-input" type="radio" name="impact_count" id="issue-input-count-input-multiple" value="multiple" :checked="impact_count == 'multiple'">
                <label class="form-check-label" for="issue-input-count-input-multiple">Multiple</label>
            </div>
            <div class="form-check my-2">
                <input class="form-check-input" type="radio" name="impact_count" id="issue-input-count-input-all" value="all" :checked="impact_count == 'all'">
                <label class="form-check-label" for="issue-input-count-input-all">All</label>
            </div>
            <div class="my-4">
                <div class="input-group">
                    <div class="form-floating">
                        <input id="issue-impact-input" name="impact" :placeholder="filteredTermTitle +  ' affected'" class="form-control focus-outline focus-outline-primary focus-ring focus-ring-primary" v-model="jiraImpact">
                        <label for="issue-impact-input">{{ filteredTermTitle }} affected</label>
                    </div>
                </div>
                <small class="my-1">Please provide examples of {{ filteredTerm }} that are affected by this issue.</small>
            </div>
            <div>
                <h2 class="my-3">Priority</h2>
                <p>In your opinion, what priority should be given to this issue?</p>
                <div class="form-check my-2">
                    <input class="form-check-input" type="radio" name="priority" id="issue-priority-input-low" :value="jiraPriorityLowest.name" :checked="priority == jiraPriorityLowest.name || priority == ''" @change="jiraPriorityChanged()">
                    <label class="form-check-label" for="issue-priority-input-low">{{ jiraPriorityLowest.display_name }} <small>({{ jiraPriorityLowest.description }})</small></label>
                </div>
                <div class="form-check my-2">
                    <input class="form-check-input" type="radio" name="priority" id="issue-priority-input-medium" :value="jiraPriorityLow.name" :checked="priority == jiraPriorityLow.name || priority == jiraPriorityMedium.name" @change="jiraPriorityChanged()">
                    <label class="form-check-label" for="issue-priority-input-medium">{{ jiraPriorityLow.display_name }} <small>({{ jiraPriorityLow.description }})</small></label>
                </div>
                <div class="form-check my-2">
                    <input class="form-check-input" type="radio" name="priority" id="issue-priority-input-high" :value="jiraPriorityHigh.name" :checked="priority == jiraPriorityHigh.name" @change="jiraPriorityChanged()">
                    <label class="form-check-label" for="issue-priority-input-high">{{ jiraPriorityHigh.display_name }} <small>({{ jiraPriorityHigh.description }})</small></label>
                </div>
                <div class="form-check my-2">
                    <input class="form-check-input" type="radio" name="priority" id="issue-priority-input-highest" :value="jiraPriorityHighest.name" :checked="priority == jiraPriorityHighest.name" @change="jiraPriorityChanged()">
                    <label class="form-check-label" for="issue-priority-input-highest">{{ jiraPriorityHighest.display_name }} <small>({{ jiraPriorityHighest.description }})</small></label>
                </div>
            </div>
        </div>
        <input type="hidden" name="priority_changed" :value="priorityChanged" />
        <div class="col-md-6 col-12">
            <h2 class="my-3">New Evidence</h2>
            <div class="my-3">
                <label class="form-label">Media</label>
                <Uploader
                    :server="temporary_media_upload_route"
                    :is-invalid="false"
                />
                <small class="my-1">Please annotate images (eg. using software like Greenshot) to ensure issues are as clearly highlighted as possible.</small>
            </div>
            <div class="my-4">
                <multiple-file-input/>
            </div>
        </div>
        <div class="col-12 text-end">
            <button v-if="issue == undefined" id="issues-create-submit-button" class="align-self-end btn-secondary btn-lg btn text-nowrap rounded-0 shadow" type="submit"><i class="fa-solid fa-floppy-disk me-1"></i> Save Ticket</button>
            <button v-if="issue != undefined" id="issues-create-submit-button" class="align-self-end btn-secondary btn-lg btn text-nowrap rounded-0 shadow" type="submit"><i class="fa-solid fa-floppy-disk me-1"></i> Save Update</button>
        </div>
    </div>
</template>

<script>
import errors from './errors.vue';
import multipleFileInput from './multiple-file-input.vue';

    export default {
        name: "issue-details-form",
        data() {
            return {
                selectedProjectId: null,
                media: {
                    saved: [],
                    added: [],
                    removed: []
                },
                priorityChanged: 0,
                jiraSummary: this.jira_summary,
                jiraDescription: this.jira_description,
                jiraUpdate: this.jira_update,
                jiraUrl: this.url,
                jiraImpact: this.impact,
            }
        },
        mounted() {
            this.selectedProjectId = this.selected_project_id
            this.selectedProjectElementId = this.selected_project_element_id
        },
        props: [
            'error_bag',
            'impact',
            'impact_count',
            'issue',
            'jira_description',
            'jira_summary',
            'jira_update',
            'priority',
            'projects',
            'project_elements',
            'selected_project_id',
            'selected_project_element_id',
            'temporary_media_upload_route',
            'uploaderUrl',
            'url',
            'jiraPriorityLowest',
            'jiraPriorityLow',
            'jiraPriorityMedium',
            'jiraPriorityHigh',
            'jiraPriorityHighest',
        ],
        methods: {
            jiraPriorityChanged() {
                this.priorityChanged = 1;
            }
        },
        computed: {
            filteredProjectElements() {
                if (this.selectedProjectId != '' && this.project_elements[this.selectedProjectId] != undefined) {
                    return this.project_elements[this.selectedProjectId];
                }

                return [];
            },
            filteredTerm() {
                if (this.selectedProjectId != '') {
                    var selectedProjectId = this.selectedProjectId;
                    var project = this.projects.find(function (element) {
                        return element.id == selectedProjectId;
                    });
                    if (project) {
                        return project.plural_terminology
                    }
                }

                return '';
            },
            filteredTermTitle() {
                if (this.filteredTerm[0] != undefined) {
                    return this.filteredTerm[0].toUpperCase() + this.filteredTerm.slice(1)
                }
            }
        },
        components: {
            'multiple-file-input': multipleFileInput,
            'errors': errors
        }
    };
</script>
